import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoginPage } from "@/features/login/components/LoginPage";
import { useAuthStore } from "@/lib/auth-store";
import { waitForAuthHydration } from "@/lib/auth-hydration";

/**
 * `/login` · si el usuario ya tiene sesión, lo redirigimos al dashboard
 * antes de pintar nada (evita ver el formulario por un frame).
 */
export const Route = createFileRoute("/login")({
  beforeLoad: async () => {
    await waitForAuthHydration();
    const { accessToken } = useAuthStore.getState();
    if (accessToken) {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: LoginPage,
});
